<template>
  <div id="todo-bin">
    <TodoNav></TodoNav>
    <h1>휴지통</h1>
    <transition-group name="list" tag="ul">
      <li v-for="todoItem in filteredTodos" :key="todoItem.id" class="shadow">
        <span class="ctg">{{ todoItem.ctg }}</span>
        <span class="title">
          <span v-bind:class="{text: todoItem.status}">
            {{ todoItem.title }}
          </span>
        </span>
        <span class="deadline">
          {{ todoItem.deadline }}
        </span>
        <span class="restoreBtn" v-on:click="restoreTodo(todoItem.id)">
          <i class="fas fa-recycle"></i>
        </span>
      </li>
    </transition-group>
    <div class="remove">
      <b-button size="lg" variant="danger" v-on:click=removeAll>휴지통 비우기</b-button>
    </div>
  </div>
</template>

<script>
import { authRef } from '../store/db.js';
import TodoNav from './TodoNav.vue'

export default {
  methods: {
    restoreTodo(id) {
      if(confirm('복원 하시겠습니까?')){
          this.$store.dispatch('RestoreTodo',id);
      }
    },
    removeAll(){
      this.$store.dispatch('DeleteComplete');
    }
  },
  computed: {
    filteredTodos: function(){
      return this.$store.getters.getTodos.filter((todo) => {
        if(this.user == todo.user && todo.remove){
              return todo.title.match(this.search);
        }
      });
    }
  },
  beforeCreate(){
      authRef.onAuthStateChanged(user=>{
          if(!user) this.$router.push('/');
          else{
              this.$store.commit('userAuth', user);
              this.user = this.$store.getters.getAuth.email;
          }
      })
  },
  created(){
    this.$store.dispatch('getTodos');
  },
  components:{
    'TodoNav': TodoNav,
  }
}
</script>

<style scoped>
  #todo-bin{
    width: 100%;
    margin: 0; 
    padding-left: 1rem;
    padding-right: 1rem; 
    font-style: normal; 
  }  
   ul {
    clear: both;
    list-style-type: none;
    padding-left: 0px;
    margin-top: 0;
    text-align: center;
    width: 100%;
  }
  li {
    display: flex;
    min-height: 30px;
    height: 30px;
    line-height: 30px;
    margin: 0.5rem 0;
    padding: 0 0.9rem;
    background: white;
    border-radius: 5px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .ctg{
    width: 15%; 
    text-align: center;
  }
  .title{
    width: 50%; 
    text-align: center;
  }
  .text{
    color: red;
    text-decoration: line-through; 
  }
  .deadline{
    width: 20%;
    text-align: center; 
  }
  .restoreBtn {
    width: 20%;
    text-align: right;
    color: green; 
  }
  h1{
    margin-top: 2%; 
  }

</style>



// WEBPACK FOOTER //
// src/components/TodoBin.vue